import { ExternalLinks } from './type'

const faqDomainUrl = process.env.NEXT_PUBLIC_FAQ_DOMAIN || ''

export const LCL_EXTERNAL_LINKS: ExternalLinks = {
  cguLink:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633c2d84f343514cadd7c3d0_LCL%20-%20CGU_Plateforme%20de%20gestion%20Okali%20x%20Client%20final_Vdef%20(1).pdf',
  bankingOrganizationPrivacyPolicyLink:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633c5a32c093a77bbf7d89e3_ca_Politique%20de%20protection%20des%20donnees%20Okali%20x%20Essentiel%20Pro_VF-n.pdf',
  brandPrivacyPolicyLink: 'https://www.lcl.fr/politique-protection-des-donnees',
  appStoreLink: 'https://apps.apple.com/us/app/essentiel-pro-lcl/id1618398607',
  googlePlayLink: 'https://play.google.com/store/apps/details?id=com.lcl.pro',
  faq: faqDomainUrl,
  mandateSepa: `${faqDomainUrl}/hc/fr/articles/5605100609821`,
  invoicingFaq: `${faqDomainUrl}/hc/fr/sections/5289100886941`,
  requestHelp: `${faqDomainUrl}/hc/fr/requests/new`,
  rcProInfo: '',
  decadeGuaranteeInfo: '',
  multiriskInfo: '',
  legalPlace:
    'https://essentielpro.legalplace.fr/contrats/micro-entreprise-essentielpro/creer/1',
  helpNonDiffusible: `${faqDomainUrl}/hc/fr/articles/5517198573597`,
  helpNonEligible: `${faqDomainUrl}/hc/fr/articles/5517826655773`,
  helpBeneficialOwners: `${faqDomainUrl}/hc/fr/articles/6653041523741`,
  urssaf: {
    portal: 'http://autoentrepreneur.urssaf.fr/',
    microEntrepreneurs:
      'https://www.autoentrepreneur.urssaf.fr/portail/accueil/sinformer-sur-le-statut/lessentiel-du-statut.html',
    socialContributions: 'http://www.aquoiserventlescotisations.urssaf.fr/',
    sepaMandate: `${faqDomainUrl}/hc/fr/articles/5605100609821`,
    faq: '',
    tdaeStatusHelp: '',
    tdaePaymentAuthorization: '',
    cgu:
      'https://assets.website-files.com/62baffcf7b968d00045514af/633aedcc31a7e75717e02246_LCL%20-%20CGU%20Tierce%20De%CC%81claration%20Client%20final%20x%20URSSAF-2_VF%20(1).pdf',
  },
  faqWhoIsBlankFor: `${faqDomainUrl}/hc/fr/articles/5661620067741`,
  psdFAQ: '',
  legalLink: 'https://info.essentielpro.lcl.fr',
  supportEmail: 'support@essentielpro.lcl.fr',
  sepaTransfer: `${faqDomainUrl}/hc/fr/articles/5605100609821`,
  compareOffers:
    'https://www.lcl.fr/professionnel/compte-bancaire-professionnel/compte-essentiel-pro-en-ligne',
  cguBankAccount:
    'https://assets.website-files.com/62baffcf7b968d00045514af/633c2d9892b68fb22a090176_LCL%20-%20Contrat%20cadre%20de%20services%20de%20paiement%20Okali%20x%20client%20final.Vdef%20(1).pdf',
  kycHelp: `${faqDomainUrl}/hc/fr/articles/6986829659933`,
}
